// Module
var code = `<div ng-if="\$root.apiState.totalApiRunning > 0" class="progress-bar-inner"> <div class="progress-indicator bg-base-100"></div> </div> <div ng-if="\$root.apiState.blockApiCount > 0" class="loading-blocker"></div>`;
// Exports
export default code;